import filterList from '../../../filters/filterList';
import { getSearchParametersFromObject } from '../../../../abstracts/url.js';
import tagmanager from '../../../../abstracts/tagmanager.js';

const accommodationFilterList = (filters, country, federalState, page) => ({
  ...filterList(filters, country, federalState, page),

  afterInit() {},

  getSearchParams() {
    return getSearchParametersFromObject({
      filters: {
        category: this.filters.category,
        classification: this.filters.classification,
        facility: this.filters.facility,
      },
      page: this.page,
    });
  },

  trackEvent(event, selection) {
    tagmanager.event(event, {
      Category: 'accommodation',
      Selection: selection ?? false,
      Country: this.country,
      Federalstate: this.federalState,
    });
  },
});

export default accommodationFilterList;
